import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "row",
  id: "pending-recruit"
}
const _hoisted_3 = { class: "col-12 card" }
const _hoisted_4 = { class: "row mx-2 my-5" }
const _hoisted_5 = { class: "col-sm-12 col-md-8" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 card" }
const _hoisted_8 = { class: "text-center mt-5" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "h2" }
const _hoisted_11 = { class: "applicant-contact mb-0 w-50 m-auto" }
const _hoisted_12 = { class: "applicant-contact mb-5 w-50 m-auto" }
const _hoisted_13 = { class: "mx-5" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { key: 3 }
const _hoisted_21 = { key: 4 }
const _hoisted_22 = ["href"]
const _hoisted_23 = { key: 5 }
const _hoisted_24 = ["href", "download"]
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "col-sm-12 col-md-4" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-md-12" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-md-12" }
const _hoisted_32 = {
  key: 0,
  class: "row"
}
const _hoisted_33 = { class: "col-md-12" }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-12" }
const _hoisted_37 = { class: "row mb-2" }
const _hoisted_38 = { class: "col-md-12" }
const _hoisted_39 = { key: 2 }
const _hoisted_40 = { class: "row mb-2" }
const _hoisted_41 = { class: "col-md-12" }
const _hoisted_42 = { class: "col-md-12" }
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = { key: 0 }
const _hoisted_45 = {
  key: 1,
  class: "text-primary"
}
const _hoisted_46 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_47 = {
  key: 0,
  class: "text-primary"
}
const _hoisted_48 = { class: "row mb-2" }
const _hoisted_49 = { class: "col-md-12" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = { key: 2 }
const _hoisted_53 = { key: 3 }
const _hoisted_54 = { key: 4 }
const _hoisted_55 = { key: 5 }
const _hoisted_56 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_join_links = _resolveComponent("join-links")!
  const _component_modal = _resolveComponent("modal")!
  const _component_schedule_form = _resolveComponent("schedule-form")!
  const _component_currency_input = _resolveComponent("currency-input")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading && typeof(_ctx.pendingUser) !== 'undefined')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("img", {
                          class: "rounded-circle",
                          width: "100",
                          src: _ctx.pendingUser.user.image
                        }, null, 8, _hoisted_9),
                        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.pendingUser.user.name), 1),
                        _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.pendingUser.user.email), 1),
                        _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.pendingUser.user.mobile_number), 1),
                        _cache[17] || (_cache[17] = _createElementVNode("hr", { class: "hr-dark" }, null, -1))
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("p", null, [
                          _createElementVNode("small", null, "Submitted " + _toDisplayString(_ctx.moment(_ctx.pendingUser.created_at).format('MM/DD/YY')), 1)
                        ]),
                        _cache[19] || (_cache[19] = _createElementVNode("h4", null, "Experience", -1)),
                        _createElementVNode("p", null, _toDisplayString(_ctx.pendingUser.user.experience), 1),
                        _cache[20] || (_cache[20] = _createElementVNode("h4", null, "Availabilities", -1)),
                        (_ctx.pendingUser.user.availabilities.length == 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_14, "No Availability"))
                          : (_openBlock(), _createElementBlock("ul", _hoisted_15, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingUser.user.availabilities, (availability) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: availability.id
                                }, [
                                  _createElementVNode("small", null, _toDisplayString(availability.day) + " " + _toDisplayString(_ctx.moment(availability.start_time, ["HH:mm:ss"]).format("hh:mm A")) + " - " + _toDisplayString(_ctx.moment(availability.end_time, ["HH:mm:ss"]).format("hh:mm A")), 1)
                                ]))
                              }), 128))
                            ])),
                        _cache[21] || (_cache[21] = _createElementVNode("h4", null, "Roles Applied", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: role.id
                          }, [
                            (this.hasAppliedForRole(role.id, false))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  (role.id == _ctx.UserRole.AUTHOR)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, "SP-ED "))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(_toDisplayString(role.name), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (role.id == _ctx.UserRole.AUTHOR && this.hasAppliedForRole(role.id, true))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, " Simclusive Author"))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128)),
                        _cache[22] || (_cache[22] = _createElementVNode("h4", null, "Time Zone", -1)),
                        (_ctx.pendingUser.user.timezone)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.pendingUser.user.timezone.title), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_20, "Not Set")),
                        _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
                        (_ctx.pendingUser.user.resume !== null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createElementVNode("a", {
                                href: _ctx.pendingUser.user.resume,
                                download: ""
                              }, "Download Resume", 8, _hoisted_22)
                            ]))
                          : _createCommentVNode("", true),
                        _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
                        (_ctx.pendingUser.user.headshot !== null)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              _cache[18] || (_cache[18] = _createElementVNode("p", null, "Headshot (right click and select \"Save Image As\" to download)", -1)),
                              _createElementVNode("a", {
                                href: _ctx.pendingUser.user.headshot,
                                download: _ctx.pendingUser.user.name,
                                target: "_blank"
                              }, [
                                _createElementVNode("img", {
                                  class: "w-100",
                                  src: _ctx.pendingUser.user.headshot
                                }, null, 8, _hoisted_25)
                              ], 8, _hoisted_24)
                            ]))
                          : _createCommentVNode("", true),
                        _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1))
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  (_ctx.pendingUser.interview !== null)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _cache[28] || (_cache[28] = _createElementVNode("div", { class: "row mt-2" }, [
                          _createElementVNode("div", { class: "col-md-12" }, [
                            _createElementVNode("p", null, [
                              _createElementVNode("strong", null, "Interview Scheduled")
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("p", null, "An interview has been scheduled by " + _toDisplayString(_ctx.pendingUser.interview.trainer.name) + " for " + _toDisplayString(_ctx.moment(_ctx.pendingUser.interview.utc_time || _ctx.pendingUser.interview.local_time).format('MM/DD/YY h:mm a')) + ".", 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createVNode(_component_join_links, {
                              joinevent: _ctx.pendingUser.interview,
                              label: 'Interview',
                              user: _ctx.user
                            }, null, 8, ["joinevent", "user"])
                          ])
                        ]),
                        (!_ctx.pendingUser.interview.is_complete)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-secondary btn-md w-100 mb-2",
                                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showCancelInterviewModal && _ctx.showCancelInterviewModal(...args)))
                                }, "Cancel Interview")
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_modal, {
                          modelValue: _ctx.cancelInterviewModal,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.cancelInterviewModal) = $event))
                        }, {
                          header: _withCtx(() => _cache[26] || (_cache[26] = [
                            _createTextVNode("Cancel Interview")
                          ])),
                          default: _withCtx(() => [
                            _cache[27] || (_cache[27] = _createElementVNode("p", null, "Are you sure you want to cancel this interview?", -1)),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-primary btn-xs float-end",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelInterview && _ctx.cancelInterview(...args)))
                            }, "Cancel Interview")
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]))
                    : (_ctx.pendingUser.interview_requests.length !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _cache[32] || (_cache[32] = _createElementVNode("div", { class: "row mt-2" }, [
                            _createElementVNode("div", { class: "col-md-12" }, [
                              _createElementVNode("p", null, [
                                _createElementVNode("strong", null, "Interview Requested")
                              ])
                            ])
                          ], -1)),
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("p", null, "An interview has been requested by " + _toDisplayString(_ctx.pendingUser.interview_requests[0].trainer.name) + " for the following dates:", 1),
                              _createElementVNode("ul", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingUser.interview_requests[0].dates, (date) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: date.id
                                  }, _toDisplayString(_ctx.moment(date.local_time).format('MM/DD/YY h:mm a')), 1))
                                }), 128))
                              ]),
                              _cache[29] || (_cache[29] = _createElementVNode("p", null, [
                                _createElementVNode("small", null, "To reschedule please cancel the request")
                              ], -1))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-secondary btn-md w-100 mb-2",
                                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showCancelRequestModal && _ctx.showCancelRequestModal(...args)))
                              }, "Cancel Request")
                            ])
                          ]),
                          _createVNode(_component_modal, {
                            modelValue: _ctx.cancelRequestModal,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.cancelRequestModal) = $event))
                          }, {
                            header: _withCtx(() => _cache[30] || (_cache[30] = [
                              _createTextVNode("Cancel Interview Request")
                            ])),
                            default: _withCtx(() => [
                              _cache[31] || (_cache[31] = _createElementVNode("p", null, "Are you sure you want to cancel this request?", -1)),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-primary btn-xs float-end",
                                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.cancelRequest && _ctx.cancelRequest(...args)))
                              }, "Cancel Interview Request")
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _cache[33] || (_cache[33] = _createElementVNode("div", { class: "row mt-2" }, [
                            _createElementVNode("div", { class: "col-md-12" }, [
                              _createElementVNode("p", null, [
                                _createElementVNode("strong", null, "Schedule an Interview"),
                                _createTextVNode(),
                                _createElementVNode("small", null, "Please select two dates")
                              ])
                            ])
                          ], -1)),
                          _createVNode(_component_schedule_form, {
                            field: "interview_date_one",
                            "alt-field": "interview_date_two",
                            "start-date": new Date(),
                            onUpdateDate: _ctx.setDate
                          }, null, 8, ["start-date", "onUpdateDate"]),
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-secondary btn-md w-100 my-2",
                                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.scheduleInterview && _ctx.scheduleInterview(...args)))
                              }, "Send Scheduling Request to Applicant")
                            ])
                          ])
                        ])),
                  _cache[48] || (_cache[48] = _createElementVNode("div", { class: "row mt-2" }, [
                    _createElementVNode("div", { class: "col-md-12" }, [
                      _createElementVNode("p", null, [
                        _createElementVNode("strong", null, "Role Settings"),
                        _createTextVNode(),
                        _createElementVNode("small", null, "To approve, please select roles and assign pay rates.")
                      ])
                    ])
                  ], -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: role.id,
                      class: "row"
                    }, [
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("label", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            value: true,
                            "onUpdate:modelValue": ($event: any) => ((_ctx.selected_roles[role.id]) = $event)
                          }, null, 8, _hoisted_43), [
                            [_vModelCheckbox, _ctx.selected_roles[role.id]]
                          ]),
                          _cache[34] || (_cache[34] = _createTextVNode()),
                          (role.id == _ctx.UserRole.AUTHOR)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_44, "SP-ED "))
                            : _createCommentVNode("", true),
                          _createTextVNode(_toDisplayString(role.name) + " ", 1),
                          (this.hasAppliedForRole(role.id, false))
                            ? (_openBlock(), _createElementBlock("strong", _hoisted_45, "Applied"))
                            : _createCommentVNode("", true)
                        ]),
                        _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("label", null, [
                          _cache[35] || (_cache[35] = _createElementVNode("small", null, "Rate:", -1)),
                          _cache[36] || (_cache[36] = _createTextVNode()),
                          _createVNode(_component_currency_input, {
                            modelValue: _ctx.role_rates[role.id],
                            "onUpdate:modelValue": ($event: any) => ((_ctx.role_rates[role.id]) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ])
                      ]),
                      (role.id == _ctx.UserRole.AUTHOR)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                            _createElementVNode("label", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                value: true,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selected_roles['simclusive_author']) = $event))
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.selected_roles['simclusive_author']]
                              ]),
                              _cache[38] || (_cache[38] = _createTextVNode(" Simclusive Author ")),
                              (this.hasAppliedForRole(role.id, true))
                                ? (_openBlock(), _createElementBlock("strong", _hoisted_47, "Applied"))
                                : _createCommentVNode("", true)
                            ]),
                            _cache[41] || (_cache[41] = _createElementVNode("br", null, null, -1)),
                            _createElementVNode("label", null, [
                              _cache[39] || (_cache[39] = _createElementVNode("small", null, "Rate:", -1)),
                              _cache[40] || (_cache[40] = _createTextVNode()),
                              _createVNode(_component_currency_input, {
                                modelValue: _ctx.role_rates['simclusive_author'],
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.role_rates['simclusive_author']) = $event))
                              }, null, 8, ["modelValue"])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("button", {
                        class: "btn btn-secondary btn-md w-100 my-2",
                        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.showApproveApplicationModal && _ctx.showApproveApplicationModal(...args)))
                      }, "Approve Applicant"),
                      _createElementVNode("button", {
                        class: "btn btn-secondary btn-md w-100",
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.showRejectApplicationModal && _ctx.showRejectApplicationModal(...args)))
                      }, "Reject Applicant")
                    ])
                  ]),
                  _createVNode(_component_modal, {
                    modelValue: _ctx.approveApplicationModal,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.approveApplicationModal) = $event))
                  }, {
                    header: _withCtx(() => _cache[42] || (_cache[42] = [
                      _createTextVNode("Approve Application")
                    ])),
                    default: _withCtx(() => [
                      _cache[43] || (_cache[43] = _createElementVNode("p", null, "Are you sure you want to approve this application?", -1)),
                      _cache[44] || (_cache[44] = _createElementVNode("p", null, "Approving for the following roles:", -1)),
                      _createElementVNode("ul", null, [
                        (_ctx.selected_roles[_ctx.UserRole.SP])
                          ? (_openBlock(), _createElementBlock("li", _hoisted_50, "Standardized Patient - Rate: $" + _toDisplayString(_ctx.role_rates[_ctx.UserRole.SP]), 1))
                          : _createCommentVNode("", true),
                        (_ctx.selected_roles[_ctx.UserRole.OBSERVER])
                          ? (_openBlock(), _createElementBlock("li", _hoisted_51, "Observer - Rate: $" + _toDisplayString(_ctx.role_rates[_ctx.UserRole.OBSERVER]), 1))
                          : _createCommentVNode("", true),
                        (_ctx.selected_roles[_ctx.UserRole.TRAINER])
                          ? (_openBlock(), _createElementBlock("li", _hoisted_52, "Trainer - Rate: $" + _toDisplayString(_ctx.role_rates[_ctx.UserRole.TRAINER]), 1))
                          : _createCommentVNode("", true),
                        (_ctx.selected_roles[_ctx.UserRole.AUTHOR])
                          ? (_openBlock(), _createElementBlock("li", _hoisted_53, "SP-ED Author - Rate: $" + _toDisplayString(_ctx.role_rates[_ctx.UserRole.AUTHOR]), 1))
                          : _createCommentVNode("", true),
                        (_ctx.selected_roles['simclusive_author'])
                          ? (_openBlock(), _createElementBlock("li", _hoisted_54, "Simclusive Author - Rate: $" + _toDisplayString(_ctx.role_rates['simclusive_author']), 1))
                          : _createCommentVNode("", true),
                        (_ctx.selected_roles[_ctx.UserRole.REVIEWER])
                          ? (_openBlock(), _createElementBlock("li", _hoisted_55, "Reviewer - Rate: $" + _toDisplayString(_ctx.role_rates[_ctx.UserRole.REVIEWER]), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary btn-xs float-end",
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.approveApplication && _ctx.approveApplication(...args)))
                      }, "Approve Application")
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_modal, {
                    modelValue: _ctx.rejectApplicationModal,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.rejectApplicationModal) = $event))
                  }, {
                    header: _withCtx(() => _cache[45] || (_cache[45] = [
                      _createTextVNode("Reject Application")
                    ])),
                    default: _withCtx(() => [
                      _cache[46] || (_cache[46] = _createElementVNode("p", null, "Are you sure you want to reject this application?", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        class: "w-100",
                        placeholder: "Please provide a note as to why this application was rejected.",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.rejectForm.rejection_note.value) = $event)),
                        onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.validateRejectNote && _ctx.validateRejectNote(...args)))
                      }, null, 544), [
                        [_vModelText, _ctx.rejectForm.rejection_note.value]
                      ]),
                      _cache[47] || (_cache[47] = _createElementVNode("p", { class: "small" }, "This information will be used for internal tracking purposes and is not shared with applicant.", -1)),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary btn-xs float-end",
                        onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.rejectApplication && _ctx.rejectApplication(...args)))
                      }, "Reject Application")
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading && typeof(_ctx.pendingUser) === 'undefined')
      ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
          _cache[49] || (_cache[49] = _createElementVNode("p", null, "Error Loading User", -1)),
          _createElementVNode("p", null, _toDisplayString(_ctx.loadErrorMessage), 1)
        ]))
      : _createCommentVNode("", true),
    _cache[50] || (_cache[50] = _createElementVNode("br", null, null, -1)),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}